<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="消费者编号"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.consumerId"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="消费者名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.consumerName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="电话"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.phoneStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="地址"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="零售户名称"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="扫码时间"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.scanTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="获得抽奖次数"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.raffleTotal"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="已抽奖次数"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.raffledCount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              照片信息
            </h3>
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
import { initAppConsumerStoreScanGetRaffleRecordApi } from '@/api/appConsumerStoreScanGetRaffleRecord'
export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
      },
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picList = []
        this.dialogAddEditViewForm = {}
        this.initPageData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initAppConsumerStoreScanGetRaffleRecordApi({ id: this.dataId }).then(res => {
        const { data } = res
        this.dialogAddEditViewForm = data
        if (data.attachmentList && data.attachmentList.length > 0) {
            data.attachmentList.forEach(item => {
              let obj = {}
              obj.name = item.attachmentName
              obj.url = this.baseUrl + item.attachmentUrl
              obj.attachmentName = item.attachmentName
              obj.attachmentUrl = item.attachmentUrl
              this.picList.push(obj)
            })
          }
        this.loading = false
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>

</style>
